import React, { useEffect } from 'react';
import { connect } from 'react-redux';

import styled from 'styled-components';

import { toggleModal, toggleSpinner } from 'apps/auth/actions/appAction';
import { addExtras } from 'apps/auth/actions/extraAction';
import { CountryItemPanel } from 'apps/auth/components/common/components/CountryItemPanel/CountryItemPanel';
import { FlagIcon } from 'apps/auth/components/common/FlagIcon/FlagIcon';
import { CommonPage } from 'apps/auth/components/common/Layout/CommonPage/CommonPage';
import { HeaderPanel } from 'apps/auth/components/common/Layout/HeaderPanel/HeaderPanel';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Text } from 'apps/auth/components/common/Text/Text';
import { InputSearch } from 'apps/auth/components/form/components/InputSearch';
import BasePage from 'apps/auth/components/utils/BasePage';
import { AUTH_PROFILE_LIMITS } from 'apps/auth/constants/UrlConstants';
import { apiFetchData } from 'apps/auth/helpers/api';
import { isObject } from 'apps/auth/helpers/utils';

import ModalDocsList from './ModalDocsList';
import ModalSearchCountryList from './ModalSearchCountryList';

const CountriesContainer = styled.div`
    display: flex;
    flex-direction: row;
    align-items: flex-start;
`;

const RecentCountryItem = styled.div`
    padding: 16px 8px;
    width: 33.33%;
    min-width: 33.33%;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    text-align: center;
    box-sizing: border-box;
    cursor: pointer;

    &:hover {
        background: ${(props) => props.theme.grey_8_lc};
    }
`;

const FlagWrapper = styled.div`
    margin-bottom: 8px;
`;

const AUTH_KYC_DOCS_LIST = '/auth/kyc/docs-list';

const SelectCountryBlock = (props) => {
    useEffect(() => {
        if (props.docs) {
            props.toggleModal(true, <ModalDocsList docs={props.docs} country={props.userCountry} />, false);
        }
    }, [props.docs]);

    const doRequest = (e, url, country) => {
        e.preventDefault();
        props.toggleModal(false);
        props.toggleSpinner(true);
        apiFetchData(url + '/' + country.code.toLowerCase())
            .then((json) => {
                if (json?.extra) {
                    props.addExtras(json.extra);
                }
                props.toggleSpinner(false);
            })
            .catch(() => {
                props.toggleSpinner(false);
            });
    };

    return (
        <CommonPage backUrl={AUTH_PROFILE_LIMITS} showChat={false}>
            <HeaderPanel title={props.title} />
            <Row indent="48px">
                <Text variant="div" color="secondary" size="subheader" indent="adaptive-24-32">
                    {props.suggestedLabel}
                </Text>
                <CountriesContainer>
                    <RecentCountryItem
                        onClick={(e) => {
                            doRequest(e, AUTH_KYC_DOCS_LIST, props.suggestedCountry);
                        }}
                    >
                        <FlagWrapper>
                            <FlagIcon name={props.suggestedCountry.code.toLowerCase()} size="small" />
                        </FlagWrapper>
                        <Text size="secondary">{props.suggestedCountry.name}</Text>
                    </RecentCountryItem>
                </CountriesContainer>
            </Row>
            <Text variant="div" color="secondary" size="subheader" indent="adaptive-24-32">
                {props.nationalityLabel}
            </Text>
            <InputSearch
                placeholder={props.searchLabel}
                toggle={(e) => {
                    e.preventDefault();
                    props.toggleModal(true, <ModalSearchCountryList doRequest={doRequest} url={AUTH_KYC_DOCS_LIST} items={props.countries} />, false);
                }}
            />
            {isObject(props.countries) &&
                props.countries.map((country, i) => {
                    return (
                        <CountryItemPanel
                            key={i}
                            onClick={(e) => {
                                doRequest(e, AUTH_KYC_DOCS_LIST, country);
                            }}
                            flagIconName={country.code.toLowerCase()}
                            countryName={country.name}
                        />
                    );
                })}
        </CommonPage>
    );
};
const mapStateToProps = ({ extra, messages }) => ({
    title: messages.pageMessages.title,
    suggestedLabel: messages.pageMessages.suggestedLabel,
    nationalityLabel: messages.pageMessages.nationalityLabel,
    searchLabel: messages.pageMessages.searchLabel,
    countries: extra.countries,
    suggestedCountry: extra.suggestedCountry,
    docs: extra.docs,
    userCountry: extra.userCountry,
});
export default connect(mapStateToProps, {
    toggleModal,
    toggleSpinner,
    addExtras,
})(BasePage(SelectCountryBlock));
